/**
 * `/rezerwacje` — the trainer's session calendar (`pages/booking`).
 *
 * A wiring declaration, shaped as `_shell.konto.tsx` is: the slice owns which `?tab=` values exist,
 * an unrecognised one and the default are both dropped from the address, and the search is built
 * whole from a validated value rather than spread from the current one — that file says why.
 */

import { createFileRoute, useNavigate, useSearch } from '@tanstack/react-router';

import {
  BookingScreen,
  bookingClientOf,
  bookingTabOf,
  bookingTabSearch,
  ledgerClientSearch,
  validateBookingSearch,
} from '~/pages/booking';

export const Route = createFileRoute('/_shell/rezerwacje')({
  validateSearch: validateBookingSearch,
  component: BookingRoute,
});

function BookingRoute() {
  const search = useSearch({ from: '/_shell/rezerwacje' });
  const navigate = useNavigate();

  return (
    <BookingScreen
      tab={bookingTabOf(search)}
      onSelectTab={(tab) => {
        // Pushes: moving between tabs is navigation, and Back returns to the tab left.
        void navigate({ to: '.', search: () => bookingTabSearch(tab) });
      }}
      client={bookingClientOf(search)}
      onOpenClient={(customerId) => {
        // Replaces: picking a client on the list is not a step Back should walk through.
        void navigate({ to: '.', search: () => ledgerClientSearch(customerId), replace: true });
      }}
    />
  );
}
